import React from "react";
import { stageMeta } from "../lib/api";

export default function StageBadge({ stage, className = "" }) {
  const s = stageMeta(stage);
  return (
    <span
      data-testid={`stage-badge-${s.value}`}
      className={`badge ${s.className} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70"></span>
      {s.label}
    </span>
  );
}
